export const BRAND_COLOR = {
  // blackAlpha scale
  50: "rgba(20, 9, 0, 0.04)",
  100: "rgba(20, 9, 0, 0.06)",
  200: "rgba(20, 9, 0, 0.08)",
  300: "rgba(20, 9, 0, 0.16)",
  400: "rgba(20, 9, 0, 0.24)",
  500: "rgba(20, 9, 0, 0.36)",
  600: "rgba(20, 9, 0, 0.48)",
  700: "rgba(20, 9, 0, 0.64)",
  800: "rgba(20, 9, 0, 0.80)",
  900: "rgba(20, 9, 0, 0.92)",
};
